<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
                 class="query-form" @submit.native.prevent>
            <el-form-item label="视频描述">
                <el-input style='width: 200px;' v-model="queryForm.videoDesc"></el-input>
            </el-form-item>
            <el-form-item label="所属用户">
                <GridSelectU title="选择用户" style="width: 200px;" labelName="userName" labelValue="id"
                             :value="queryForm.userId" :limit='1'
                             size='small' placeholder='请选择用户' @getValue="getSeachValueUser" :columns="USER_code"
                             :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                             queryEntityUrl="/mpp/user/get">
                </GridSelectU>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getVideoVideoList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="addVideoVideo">新建</el-button>
                    <el-button type="warning" plain size="small" icon="el-icon-edit"
                               :disabled="multipleSelection.length != 1"
                               @click="editVideoVideo(null)">修改
                    </el-button>
                    <el-button type="danger" plain size="small" icon="el-icon-delete"
                               :disabled="multipleSelection.length <= 0"
                               @click="deleteVideoVideo(null)">删除
                    </el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate" class="upload-demo" action="#" :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span title="搜索" class="icon-box" @click="search">
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
                    <!-- <span title="下载模板" class="icon-box" @click="importTemplate">
                      <Icon color="#606266">
                        <ArrowDown />
                      </Icon>
                    </span>
                    <span class="icon-box" title="导入数据" @click="isImport">
                      <Icon color="#606266">
                        <ArrowExportUp24Regular />
                      </Icon>
                    </span>
                    <span title="导出数据" class="icon-box" @click="exportVideoVideoList">
                      <Icon color="#606266">
                        <ArrowDownload24Regular />
                      </Icon>
                    </span> -->
                    <span class="icon-box" @click="refreshVideoVideoList">
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table :data="videoVideoList" row-key="id" border height="100%" :header-row-style="{ height: '10px' }"
                      :header-cell-style="{ padding: '10px' }" :row-style="{ height: '9px' }"
                      :cell-style="{ padding: '9px' }" size="small">
                <el-table-column align="center" type="selection" width="60"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="videoDesc" label="视频描述"
                                 width="180">
                </el-table-column>
                <el-table-column align="center" prop="videoPic" label="视频图片" min-width="12%" width="180">
                    <template slot-scope="scope">
                        <div v-if='scope.row.videoPic'>
                            <el-image @click='updateSrcList(scope.row.videoPic)' style="width: 60px; height: 60px"
                                      :src="scope.row.videoPic" :preview-src-list="srcList"></el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="userId" label="用户" width="180">
                    <template slot-scope='scope'>
                        <div v-if="scope.row.user">
                            <div style='text-align: left'>账号：{{ scope.row.user.userName }}</div>
                            <div style='text-align: left'>手机：{{ scope.row.user.userMobile }}</div>
                            <div style='text-align: left'>昵称：{{ scope.row.user.userNickname }}</div>
                            <div style='text-align: left'>姓名：{{ scope.row.user.userRealname }}</div>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="likeNumber" label="点赞数"
                                 width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="commentNumber" label="评论数"
                                 width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="collectionNumber" label="收藏数"
                                 width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="shareNumber" label="分享数"
                                 width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="status" label="状态" width="180">
                    <template slot-scope='scope'>
                        <el-tag :type='status[scope.row.status].type'>{{ status[scope.row.status].word }}</el-tag>
                    </template>
                </el-table-column>
                <!-- <el-table-column :show-overflow-tooltip="true" align="center" prop="refuseReason" label="拒绝原因" width="180">
                </el-table-column> -->
                <!-- <el-table-column :show-overflow-tooltip="true" align="center" prop="province.areaName" label="所属省份" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="city.areaName" label="所属城市" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="area.areaName" label="所属区县" width="180">
                </el-table-column> -->
                <el-table-column :show-overflow-tooltip="true" align="center" prop="province.areaName" label="区域"
                                 width="180">
                    <template slot-scope="scope">
                        <div v-if='scope.row.province.areaName'>
                            <div>{{ scope.row.province.areaName }}{{ scope.row.city.areaName
                                }}{{ scope.row.area.areaName }}
                            </div>
                        </div>

                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime" label="创建时间"
                                 width="180">
                </el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="430">
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="playVideoVideo(scop.row.videoSrc)">
                                <i class="el-icon-video-play"></i>
                                <span class="operation-label">播放</span>
                            </div>
                            <div @click="showVideoProduct(scop.row.id)">
                                <i class="el-icon-folder-opened" size="16"></i>
                                <span class="operation-label"> 管理商品</span>
                            </div>
                            <div @click="checkVideoVideo(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editVideoVideo(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteVideoVideo(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination @size-change="sizeChange" @current-change="currentChange"
                               :current-page.sync="currentPage"
                               :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="totalNum" background :pager-count="7">
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog :title="videoVideoStates[videoVideoState]" :visible.sync="showDialog" width="60%"
                       @close="closeDialog">
                <div>
                    <el-form :model="videoVideo" ref="videoVideoForm" :rules="rules" label-width="120px" :inline="true"
                             size="small">
                        <el-form-item label="所属用户" prop="userId">
                            <GridSelectU style="width: 177px;" labelName="userName"
                                         :disabled="videoVideoState == 'check'"
                                         labelValue="id" title="选择用户" :value="videoVideo.userId" :limit='1'
                                         size='small' placeholder='请选择用户'
                                         @getValue="getValueUser" :columns="USER_code" :searchs="USER_search"
                                         dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                                         queryEntityUrl="/mpp/user/get">
                            </GridSelectU>
                        </el-form-item>
                        <el-form-item label="点赞数" prop="likeNumber">
                            <el-input style='width: 177px;' size="small" v-model="videoVideo.likeNumber"
                                      :disabled="videoVideoState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="评论数" prop="commentNumber">
                            <el-input style='width: 177px;' size="small" v-model="videoVideo.commentNumber"
                                      :disabled="videoVideoState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="收藏数" prop="collectionNumber">
                            <el-input style='width: 177px;' size="small" v-model="videoVideo.collectionNumber"
                                      :disabled="videoVideoState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="分享数" prop="shareNumber">
                            <el-input style='width: 177px;' size="small" v-model="videoVideo.shareNumber"
                                      :disabled="videoVideoState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="审核状态" prop="status">
                            <el-select placeholder="请选择状态" :disabled="videoVideoState == 'check'" clearable
                                       style="width: 177px"
                                       size="small" v-model="videoVideo.status">
                                <el-option v-for='(item, index) in productStatusEnumList' :key='index'
                                           :label="item.value"
                                           :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item label="拒绝原因" prop="refuseReason">
                          <el-input size="small" v-model="videoVideo.refuseReason" :disabled="videoVideoState == 'check'"></el-input>
                        </el-form-item> -->
                        <el-form-item label="所属省份" prop="provinceId">
                            <el-select placeholder="请选择省" :disabled="videoVideoState == 'check'"
                                       @change="clearSubitem('province')"
                                       clearable style="width: 177px" size="small" v-model="videoVideo.provinceId">
                                <el-option v-for='(item, index) in provinceArry' :key='index' :label="item.areaName"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所属城市" prop="cityId">
                            <el-select placeholder="请选择市" :disabled="videoVideoState == 'check'"
                                       @change="clearSubitem('city')"
                                       clearable style="width: 177px" size="small" v-model="videoVideo.cityId">
                                <el-option v-for='(item, index) in cityArry' :key='index' :label="item.areaName"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所属区县" prop="areaId">
                            <el-select placeholder="请选择区" :disabled="videoVideoState == 'check'" clearable
                                       style="width: 177px"
                                       size="small" v-model="videoVideo.areaId">
                                <el-option v-for='(item, index) in areaArry' :key='index' :label="item.areaName"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="视频地址" prop="videoSrc">
                            <el-input style="width: 177px" size="small" v-model="videoVideo.videoSrc"
                                      :disabled="videoVideoState == 'check'" placeholder="请上传视频">
                                <el-button slot="append" :disabled="videoVideoState == 'check'" @click="uploadVideo"
                                           icon="el-icon-video-play"></el-button>
                            </el-input>
                            <el-upload v-show="false" ref="uploads" class="uploadAlbum" :action="action"
                                       :file-list="videoFileList"
                                       :before-upload="handleBeforeUpload" :on-remove="handleVodRemove"
                                       :http-request="uploadAvatar"
                                       :on-success="onSucc" :show-file-list="false">
                                <el-button type="primary" size="small" class="as"
                                           :disabled="videoVideoState == 'check'">上传
                                </el-button>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="视频图片" prop="videoPic">
                            <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                       :disabled="videoVideoState == 'check'" class="avatar-uploader"
                                       :show-file-list="false"
                                       :http-request="uploadImage">
                                <img v-if="videoVideo.videoPic" :src="videoVideo.videoPic" class="avatar"
                                     size="small" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="视频描述" prop="videoDesc">
                            <el-input size="small" style="width: 177px;height: 177px;" placeholder="请输入视频描述"
                                      type="textarea" :rows="8"
                                      v-model="videoVideo.videoDesc" :disabled="videoVideoState == 'check'"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button type="primary" @click="submitForm" v-if="videoVideoState != 'check'">确定</el-button>
                </div>
            </el-dialog>
        </div>
        <!-- 添加商品 -->
        <el-dialog title="添加商品" :visible.sync="showAdd" width="400px" @close="closeShop" :append-to-body="true">
            <div>
                <el-form :model="shopProductClassify" ref="shopProductClassifyForm" :rules="rules" :inline="true"
                         size="small">
                    <!-- <el-form-item label="商品" prop="productIdList">
                        <GridSelectLi
                            style="width: 200px"
                            title="选择商品"
                            labelName="productName"
                            labelValue="id"
                            :did="did"
                            :value="shopProductClassify.productId"
                            :limit="99"
                            size="small"
                            placeholder="请选择商品"
                            @getValue="getValuebrandId"
                            :columns="PRODUCT_code"
                            :searchs="PRODUCT_search"
                            dataListUrl="/shop/product/findList"
                            entityBeanName="shopProduct"
                            queryEntityUrl="/shop/product/get"
                        >
                        </GridSelectLi>
                    </el-form-item> -->
                    <el-form-item label="商品" prop="productIdList">
                        <div style="display: flex;">
                            <GridSelectLi
                                ref="add1"
                                style="width: 265px;"
                                title="选择商品"
                                labelName="productName"
                                labelValue="id"
                                :did="did"
                                :value="shopProductClassify.productId"
                                :limit="99"
                                size="small"
                                placeholder="请选择商品"
                                @getValue="getValuebrandId"
                                :columns="PRODUCT_code"
                                :searchs="PRODUCT_search"
                                dataListUrl="/shop/product/findList"
                                entityBeanName="shopProduct"
                                queryEntityUrl="/shop/product/get"
                            >
                            </GridSelectLi>
                            <el-button style="height: 30px;margin: 0 4px;" type="primary" @click="add1">添加</el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>

            <div slot="footer" class="flex justify-end">
                <el-button @click="closeShop">关闭</el-button>
                <el-button type="primary" @click="shopaddForm">确定</el-button>
            </div>
        </el-dialog>

        <!--视频预览-->
        <playVideo ref="videoDiolag"></playVideo>


        <el-drawer
            title="使用记录"
            :visible.sync="playVideoStatus"
            direction="rtl"
            size="70%"
            :before-close="playVideoClose">
            <videoProduct ref="videoProduct"></videoProduct>
        </el-drawer>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_PATH, UPLOAD_API, USER, PRODUCT, PRODUCT_SEARCH, USER_SEARCH } from '@/utils/constant.js';
import GridSelectU from '@/components/gridselect';
import playVideo from '@/components/video/playVideo.vue';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import videoProduct from '@/views/video/VideoProduct.vue';
import ShopCardUse from '@/components/shop/ShopCardUse.vue';

export default {
    components: {
        ShopCardUse,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU,
        playVideo,
        GridSelectLi,
        videoProduct
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetVideoVideoList();
                this.getVideoVideoList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetVideoVideoList();
                this.getVideoVideoList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            playVideoStatus: false,

            shopProductClassify: {
                id: '', //id
                productIdList: [], //商品id
                activityId: '' //类别类型
            },
            showAdd: false,
            PRODUCT_code: PRODUCT,
            PRODUCT_search: PRODUCT_SEARCH,
            did: '',
            USER_code: USER,
            USER_search: USER_SEARCH,
            productStatusEnumList: [],//商品状态枚举
            areaTreeDate: [],//地址
            queryForm: {
                videoSrc: '', //视频地址
                videoDesc: '', //视频描述
                videoPic: '', //视频图片
                userId: '', //用户ID
                likeNumber: '', //点赞数
                commentNumber: '', //评论数
                collectionNumber: '', //收藏数
                shareNumber: '', //分享数
                status: '', //状态
                refuseReason: '', //拒绝原因
                provinceId: '', //省
                cityId: '', //市
                areaId: '' //区
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            videoVideoState: 'add',
            videoVideoStates: {
                add: '新建视频',
                check: '查看视频',
                edit: '修改视频'
            },
            srcList: [''],//大图预览
            multipleSelection: [],
            videoVideoList: [],
            videoVideo: {
                videoSrc: '', //视频地址
                videoDesc: '', //视频描述
                videoPic: '', //视频图片
                userId: '', //用户ID
                likeNumber: '0', //点赞数
                commentNumber: '0', //评论数
                collectionNumber: '0', //收藏数
                shareNumber: '0', //分享数
                status: '', //状态
                refuseReason: '', //拒绝原因
                provinceId: '', //省
                cityId: '', //市
                areaId: '' //区
            },
            btnLoading: false,
            videoFileList: [],// 视频上传列表
            fileType: ['mp4'],
            // 上传文件大小限制(MB)
            fileSize: '50',
            header: {
                token: localStorage.getItem('token')
            },
            action: UPLOAD_API + UPLOAD_PATH,
            status: [
                {
                    type: 'info',
                    word: '未提交'
                },
                {
                    type: 'warning',
                    word: '审核中'
                },
                {
                    type: 'success',
                    word: '审核成功'
                },
                {
                    type: 'danger',
                    word: '审核失败'
                }
            ],
            rules: {
                videoSrc: [{ required: true, message: '视频地址不能为空', trigger: 'blur' }],
                videoDesc: [{ required: true, message: '视频描述不能为空', trigger: 'blur' }],
                videoPic: [{ required: true, message: '视频图片不能为空', trigger: 'blur' }],
                userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                likeNumber: [{ required: true, message: '点赞数不能为空', trigger: 'blur' }],
                commentNumber: [{ required: true, message: '评论数不能为空', trigger: 'blur' }],
                collectionNumber: [{ required: true, message: '收藏数不能为空', trigger: 'blur' }],
                shareNumber: [{ required: true, message: '分享数不能为空', trigger: 'blur' }],
                status: [{ required: true, message: '状态不能为空', trigger: 'blur' }],
                refuseReason: [{ required: true, message: '拒绝原因不能为空', trigger: 'blur' }],
                provinceId: [{ required: true, message: '省不能为空', trigger: 'blur' }],
                cityId: [{ required: true, message: '市不能为空', trigger: 'blur' }],
                areaId: [{ required: true, message: '区不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getVideoVideoList();
        this.getTreeData();
    },
    mounted() {
        this.getProductStatusEnum();
    },
    computed: {
        provinceArry() {
            return this.areaTreeDate;
        },
        cityArry() {
            if (!this.provinceArry) {
                return [];
            } else {
                for (let i = 0; i < this.provinceArry.length; i++) {
                    if (this.provinceArry[i].id == this.videoVideo.provinceId) {
                        return this.provinceArry[i].children;
                    } else if (this.provinceArry[i].id == '') {
                        return [];
                    }
                }
            }
        },
        areaArry() {
            if (!this.cityArry) {
                return [];
            } else {
                for (let i = 0; i < this.cityArry.length; i++) {
                    if (this.cityArry[i].id == this.videoVideo.cityId) {
                        return this.cityArry[i].children;
                    }
                }
            }
        }
    },
    methods: {

        //删除
        add1() {
            this.$refs.add1.showSelectDialog();
            console.log(this.$refs.add1);
        },
        getValuebrandId(value) {
            console.log('1111111111111111111111111111111111111111111');
            this.shopProductClassify.productIdList = value;

            // console.log('1111111',this.shopProductClassify.productIdList)
            // console.log('2222222',this.shopProductClassify.productId)
        },
        closeShop() {
            this.shopProductClassify = {
                // id: '', //id
                productId: [], //商品id
                activityId: '' //类别类型
            };
            this.$refs.shopProductClassifyForm.resetFields();
            this.showAdd = false;
        },

        shopaddForm() {
            this.$refs.shopProductClassifyForm.validate((valid) => {
                if (valid) {
                    console.log('submit');
                    console.log(this.shopProductClassify);
                    // console.log(this.shopProductClassifyList);
                    post(`/shop/store/addBatch`, { ...this.shopProductClassify }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.closeShop();
                        }
                    });
                }
            });
        },


        // 获取商品状态枚举
        getProductStatusEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'audit_status'
            }).then((res) => {
                if (res.success) {
                    this.productStatusEnumList = res.enumList;
                    console.log(this.productStatusEnumList);
                }
            });
        },
        // 搜索用户
        getSeachValueUser(value) {
            this.queryForm.userId = value;
        },
        getValueUser(value) {
            this.videoVideo.userId = value;
        },
        //上传缩略图
        uploadImage(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.videoVideo.videoPic = res.url;
                }
            });
        },
        handleVodRemove(file, fileList) {
            for (let i = 0; i < this.temporaryList.length; i++) {
                if (file.response.url == this.temporaryList[i]) {
                    this.temporaryList.splice(i, 1);
                }
            }
            this.albumList = this.temporaryList.join('|');
        },
        // handleSuccess(response, file, fileList) {
        //   this.temporaryList.push(file.response.url);
        //   this.albumList = this.temporaryList.join('|');
        // },
        beforeImageUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        uploadVideo() {
            this.$refs.uploads.$el.querySelector('.as').click();
            console.log(this.$refs.uploads);
        },
        //上传视频
        uploadAvatar(params) {
            const file = params.file;
            console.log(file);
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(`/mpp/file/upload`, formData).then((res) => {
                if (res.success) {
                    this.videoVideo.videoSrc = res.url;
                    this.videoVideo.videoPic = res.videoCover;
                    console.log(this.videoVideo.videoSrc);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 上传前校检格式和大小
        handleBeforeUpload(file) {
            // console.log(this.videoVideo.videoSrc);
            // if (this.videoVideo.videoSrc != '') {
            //     this.$message.error("最多选择一个视频")
            //   return false;
            // }
            // 校检文件类型
            if (this.fileType && file) {
                let fileExtension = '';
                if (file.name.lastIndexOf('.') > -1) {
                    fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
                }
                const isTypeOk = this.fileType.some((type) => {
                    if (file.type.indexOf(type) > -1) return true;
                    if (fileExtension && fileExtension.indexOf(type) > -1) return true;
                    return false;
                });
                if (!isTypeOk && file) {
                    this.$message({
                        message: `文件格式不正确, 请上传${this.fileType.join('/')}格式文件!`,
                        type: 'error',
                        duration: 2000
                    });
                    return false;
                }
            }
            //校检文件大小;
            if (this.fileSize && file) {
                const isLt = file.size / 1024 / 1024 < this.fileSize;
                if (!isLt) {
                    this.$message({
                        message: `上传文件大小不能超过 ${this.fileSize} MB!`,
                        type: 'error',
                        duration: 2000
                    });
                    return false;
                }
            }
            return true;
        },
        handleVodRemove(file, fileList) {
            if (fileList.length == 0) {
                this.videoVideo.videoSrc = '';
                this.videoVideo.videoPic = '';
            }
        },
        onSucc(response, file, fileList) {
            console.log(this.videoFileList);
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetVideoVideoList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.videoVideoList = [];
        },
        resetDialog() {
            this.videoVideoState = 'add';
            this.showDialog = false;
            this.queryForm = {
                videoSrc: '', //视频地址
                videoDesc: '', //视频描述
                videoPic: '', //视频图片
                userId: '', //用户ID
                likeNumber: '0', //点赞数
                commentNumber: '0', //评论数
                collectionNumber: '0', //收藏数
                shareNumber: '0', //分享数
                status: '', //状态
                refuseReason: '', //拒绝原因
                provinceId: '', //省
                cityId: '', //市
                areaId: '' //区
            };
            this.getVideoVideoList();
        },
        closeDialog() {
            this.showDialog = false;
            this.videoVideo = {
                videoSrc: '', //视频地址
                videoDesc: '', //视频描述
                videoPic: '', //视频图片
                userId: '', //用户ID
                likeNumber: '0', //点赞数
                commentNumber: '0', //评论数
                collectionNumber: '0', //收藏数
                shareNumber: '0', //分享数
                status: '', //状态
                refuseReason: '', //拒绝原因
                provinceId: '', //省
                cityId: '', //市
                areaId: '' //区
            };
        },
        submitForm() {
            if (this.videoVideoState == 'add') {
                this.$refs.videoVideoForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/video/video/add`, { ...this.videoVideo }).then((res) => {
                            if (res.success || res.code == 200) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetVideoVideoList();
                                this.resetDialog();
                                this.getVideoVideoList();
                            }
                        });
                    }
                });
            } else if (this.videoVideoState == 'edit') {
                this.$refs.videoVideoForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        delete this.videoVideo.province;
                        delete this.videoVideo.city;
                        delete this.videoVideo.area;
                        delete this.videoVideo.user;
                        post(`/video/video/edit`, { ...this.videoVideo }).then((res) => {
                            if (res.success || res.code == 200) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetVideoVideoList();
                                this.resetDialog();
                                this.getVideoVideoList();
                            }
                        });
                    }
                });
            }
        },
        // 大图预览
        updateSrcList(src) {
            this.srcList[0] = src;
        },
        // 播放
        playVideoVideo(src) {
            console.log(src + '哈哈哈');
            this.$refs.videoDiolag.dialogVisible = true;
            this.$refs.videoDiolag.videoSrc = src;
        },
        addVideoVideo() {
            this.showDialog = true;
            this.videoVideoState = 'add';
        },
        checkVideoVideo(videoVideoId) {
            console.log(videoVideoId);
            this.currentVideoVideoId = videoVideoId;
            this.getVideoVideoById();
            this.showDialog = true;
            this.videoVideoState = 'check';
        },
        editVideoVideo(videoVideoId) {
            console.log('videoVideo', videoVideoId);
            if (videoVideoId) {
                this.currentVideoVideoId = videoVideoId;
                this.getVideoVideoById();
            } else {
                this.videoVideo = { ...this.videoVideo, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.videoVideoState = 'edit';
        },
        deleteVideoVideo(videoVideoId) {
            let ids = '';
            if (videoVideoId) {
                ids = videoVideoId;
            } else {
                ids = this.multipleSelection.map((videoVideo) => videoVideo.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/video/video/delete`, { ids }).then((res) => {
                        if (res.success || res.code == 200) {
                            console.log(res);
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetVideoVideoList();
                            this.getVideoVideoList();
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshVideoVideoList() {
            this.resetVideoVideoList();
            this.getVideoVideoList();
        },
        getVideoVideoList(query = {}) {
            this.loading = true;
            get(`/video/video/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success || res.code == 200) {
                    this.videoVideoList = res.page.list;
                    this.totalNum = res.page.total;
                    console.log(this.videoVideoList);
                }
            });
        },
        getVideoVideoById() {
            get(`/video/video/get`, { id: this.currentVideoVideoId }).then((res) => {
                if (res.success || res.code == 200) {
                    this.videoVideo = { ...this.videoVideo, ...res.videoVideo };
                }
            });
        },

        // 获取地理位置
        getTreeData() {
            get('/mpp/area/treeData').then((res) => {
                if (res.success) {
                    this.areaTreeDate = res.treeData[0].children;
                }
            });
        },

        // 省市区清除器
        clearSubitem(id) {
            if (id == 'province') {
                this.videoVideo.cityId = '';
                this.videoVideo.areaId = '';
            } else if (id == 'city') {
                this.videoVideo.areaId = '';
            }
        },
        /**
         * 导出信息
         */
        exportVideoVideoList() {
            //this.btnLoading = true;
            exprotExcel(`/video/video/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/video/video/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/video/video/importData`, formData);
            this.refreshVideoVideoList();
        },
        currentChange(page) {
            this.currentPage = page;
            this.getVideoVideoList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getVideoVideoList();
        },
        playVideoClose(){
            this.playVideoStatus = false
        },
        showVideoProduct(id){
            this.playVideoStatus = true
            this.$nextTick(()=>{
                this.$refs.videoProduct.show(id)
            })
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.avatar {
    width: 180px;
    height: 180px;
    display: block;
}

::v-deep .el-upload--text {
    width: 180px;
    height: 180px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 180px;
    text-align: center;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}</style>